import { useSelector } from "react-redux";

import { RootState } from "../../globals";
import { RequestStudentData } from "../../models/EnrollmentHistoryDTO";

/*
	Catálogos de los datos del alumno (país, estado, ciudad, grado, género, identificación) tal como los
	usa el formulario de solicitud. Lo comparten la solicitud y la pre-solicitud para que los dos pidan
	exactamente lo mismo (Esteban, 2026-10-03).
*/
export const useCatalogosAlumno = (datos: RequestStudentData) => {
	const basicInfo: any = useSelector((state: RootState) => state.basicInfo.value);
	const country = basicInfo?.countryRef && datos.countryId ? basicInfo.countryRef["C_" + datos.countryId] : null;
	const states: any[] = country?.states || [];
	const cities: any[] = (datos.stateId && country?.stateRef && country.stateRef["S_" + datos.stateId]) ? country.stateRef["S_" + datos.stateId].cities || [] : [];
	//Sin "Ninguno": nadie llega sin haber cursado ni un grado (Esteban, 2026-09-22).
	const academicDegrees: any[] = basicInfo?.academicDegreeRef
		? Object.values(basicInfo.academicDegreeRef).filter((d: any) => Number(d.id) !== 0) : [];
	const identificationType: any = basicInfo?.identificationTypeRef && datos.identificationTypeId ? basicInfo.identificationTypeRef["IT_" + datos.identificationTypeId] : null;
	return {
		basicInfo, states, cities, academicDegrees, identificationType,
		countries: (basicInfo?.countries || []) as any[],
		campusCountries: ((basicInfo?.countries || []) as any[]).filter((c: any) => c.bool_campus_exclusive_use < 1),
		genders: (basicInfo?.genders || []) as any[],
		identificationTypes: (basicInfo?.identificationTypes || []) as any[],
		/** Tipo de identificación que se usa en el país del plantel. */
		identificacionDelPais: (countryId: number): any => basicInfo?.countryRef?.["C_" + countryId]?.preferred_identification_type_id || ""
	};
};

/** "0801-1999-12345" → 13 dígitos en los documentos hondureños de solo números; el resto en mayúsculas sin espacios. */
export const limpiarIdentificacion = (valor: string, tipo: any): string =>
	tipo?.bool_only_digits && Number(tipo?.country_id) === 2 ? valor.replace(/\D+/g, "") : valor.toUpperCase().replace(/\s+/g, "");

export default useCatalogosAlumno;
